import React from 'react'
import { PageTitleInfo } from '../../../types/layout'

interface PageTitleProps {
  titleInfo: PageTitleInfo
}

/**
 * Componente para mostrar el título de la página con icono
 * Incluye animación fade-in al cambiar
 */
const PageTitle: React.FC<PageTitleProps> = ({ titleInfo }) => {
  return (
    <h1 className="text-base sm:text-lg font-semibold text-gray-900 flex items-center animate-fade-in leading-tight">
      {titleInfo.icon}
      <span className="truncate">{titleInfo.title}</span>
    </h1>
  )
}

export default React.memo(PageTitle)

